//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusStatusFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13.8167 13.3576L10.0901 5.95447L7.13151 10.7353H3.73145L3.73225 12.7353H7.68866H8.24581L9.91038 10.0455L13.7345 17.6424L16.4453 12.7353H20.0002V10.7353H15.2653L13.8167 13.3576Z" fill="currentColor" /></svg>;
}
export default IconStatusStatusFill;